import PreorderSlice from './PreorderSlice';

export default PreorderSlice.actions;
